import type { ClientOptions, ClientOptionsDto } from '../types';

export function clientOptionsFromDto(data: ClientOptionsDto): ClientOptions {
  return {
    sectors: data.sectors,
    relationshipStatuses: data.relationship_statuses,
    serviceAreas: data.service_areas.map((area) => ({
      id: area.id,
      name: area.name,
      businessSegment: area.business_segment,
      icon: area.icon,
      colour: area.colour,
    })),
    serviceTypes: data.service_types.map((type) => ({
      id: type.id,
      name: type.name,
      serviceAreaId: type.service_area,
      icon: type.icon,
      targetMargin: type.target_margin,
    })),
    contractTypes: data.contract_types,
    contactRights: data.contact_rights.map((rights) => ({
      id: rights.id,
      name: rights.name,
      quoteRequest: rights.quote_request,
      orderAuthorization: rights.order_authorization,
      seeClientCases: rights.see_client_cases,
      seeClientGroupCases: rights.see_client_group_cases,
    })),
    historyItemTypes: data.history_item_types,
    addressTypes: data.address_types,
    languages: data.languages,
  };
}
